export const columns = [
    { id: "s.no", label: "S.No" },
    {
      id: "Department-Name",
      label: "Name of the Department",
      minWidth: 170,
      align: "center",
    },
    {
      id: "head of the department",
      label: "Head of the Department ",
      minWidth: 170,
     
    },
  ];
  
  
  export const rows = [
      {
        "s.no": 1,
        "Department-Name": "Civil Engineering",
        "head of the department": "Dr. K. Srinivasa Prasad",
      },
      {
        "s.no": 2,
        "Department-Name": "Mechanical Engineering",
        "head of the department": "Dr. C. Neelima Devi",
      },
      {
        "s.no": 3,
        "Department-Name": "Electrical and Electronic Engineering",
        "head of the department": "Dr. A. Padmaja",
      },
      {
        "s.no": 4,
        "Department-Name": "Electronics and Communication Engineering",
        "head of the department": "Dr. B. Nalini",
      },
      {
        "s.no": 5,
        "Department-Name": "Metallurgical Engineering",
        "head of the department": "Prof. G. Swami Naidu",
      },
      {
        "s.no": 6,
        "Department-Name": "Computer Science and Engineering",
        "head of the department": "Dr. P. Aruna Kumari",
      },
      {
        "s.no": 7,
        "Department-Name": "Information Technology",
        "head of the department": "Dr. B. Tirimula Rao",
      }
  ];
  